<div class="icon">
  <mat-icon>person_add</mat-icon>
</div>
<div class="description">
  <strong>Business Signup</strong> from {{ activity.meta.source }}
  <span class="text-muted mr-1" *ngIf="activity.meta.campaign">({{ activity.meta.campaign }})</span>
  <a href="javascript:" (click)="showDetails=!showDetails">{{ showDetails ? 'Hide Details' : 'Show Details ' }}</a>
  <ul class="signup-checklist" style="margin: 10px 0 0 30px" *ngIf="showDetails">
    <li>
      {{ activity.meta.source }} {{ activity.meta.sourceIsMarketingOwner ? 'received' : 'did not receive' }} marketing
      ownership
      <ul *ngIf="!activity.meta.sourceIsMarketingOwner">
        <li *ngFor="let r of activity.meta.sourceIsNotMarketingOwnerReasons">{{ r.reason }}</li>
      </ul>
    </li>
    <li>
      Borrower was {{ activity.meta.isQualified ? '' : 'not ' }}qualified
      <ul *ngIf="!activity.meta.isQualified">
        <li *ngFor="let reason of activity.meta.notQualifiedReasons">{{ reason }}</li>
      </ul>
    </li>
    <li>
      Borrower was {{ activity.meta.reactivated ? '' : 'not ' }}reactivated
      <ul *ngIf="!activity.meta.reactivated">
        <li>{{ activity.meta.notReactivatedReason }}</li>
      </ul>
    </li>
    <li>
      Borrower was {{ activity.meta.reassigned ? '' : 'not ' }}reassigned
      <ul>
        <li *ngFor="let check of activity.meta.reassignmentChecks | keyValues" style="margin-bottom:0">
          {{ check.key }}?
          <i style="position:relative;bottom:-3px" class="{{ check.value ? 'icon-16-green-tick' : 'icon-16-red-x' }}"></i>
        </li>
      </ul>
    </li>
  </ul>
</div>
